import { lightTheme } from './light';
import { darkTheme } from './dark';
import { typography } from '../tokens/typography';
import { spacing } from '../tokens/spacing';
import { breakpoints, mediaQueries } from '../tokens/breakpoints';

export const createTheme = (theme) => ({
  ...theme,
  typography,
  spacing,
  breakpoints,
  mediaQueries,
});

export const themes = {
  light: createTheme(lightTheme),
  dark: createTheme(darkTheme),
}; 